import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail, refreshSession } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = auth

  useEffect(() => {
    const boot = async () => {
      try { setUser((await api.get("/auth/me")).data); return; } catch (e) {}
      if (await refreshSession()) {
        try { setUser((await api.get("/auth/me")).data); return; } catch (e) {}
      }
      setUser(false);
    };
    boot();
    const onLogout = () => setUser(false);
    window.addEventListener("respondia:logout", onLogout);
    const keepAlive = setInterval(() => { refreshSession(); }, 10 * 60 * 1000);
    return () => { window.removeEventListener("respondia:logout", onLogout); clearInterval(keepAlive); };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { formatApiErrorDetail };
